import { render, staticRenderFns } from "./select-boolean-checkbox.vue?vue&type=template&id=28119622"
import script from "./select-boolean-checkbox.vue?vue&type=script&lang=js"
export * from "./select-boolean-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports